import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './vyhlasenievZbierkeZakonovButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
}

const VyhlasenievZbierkeZakonovButtons = ({
  onClick,
  loading,
}: Props): ReactElement => (
  <div className="vyhlasit-v-zbierke-buttons__container">
    <ConfirmModal
      question={'Naozaj si prajete presunúť proces do štádia "Vyhlásené v Zbierke zákonov SR"?'}
      description={'Po vykonaní tohto pracovného kroku budú v detaile procesu viditeľné priradené čísla predpisov, pod '
        + 'ktorými bol proces vyhlásený, aktuálne štádium materiálu sa zmení na "Vyhlásené v Zbierke zákonov SR" a '
        + 'proces bude ukončený. Po ukončení procesu už nebude možné vykonávať žiadne pracovné kroky.'}
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <LoaderButton
          size="large"
          className="vyhlasit-v-zbierke-buttons__submit-button"
          loading={loading}
          disableOutsideClickWhileLoading
        >Prejsť do štádia Vyhlásené v Zbierke zákonov SR
        </LoaderButton>
      )}
      doAfterConfirm={onClick}
    />
    <BackButton disabled={loading} />
  </div>
);
export default VyhlasenievZbierkeZakonovButtons;
